<!-- Edit Freeze Modal -->
<p-dialog [(visible)]="visible" [resizable]="false" appendTo="body" (onHide)="HidePopup()" [modal]="true"
    [breakpoints]="{'991px': '100vw'}" [style]="{width: '500px'}" styleClass="no-header-modal overflow-visible"
    aria-label="edit-freeze-dialog" data-testid="edit-freeze-dialog">
    <ng-template pTemplate="header" styleClass="hidden"></ng-template>
    <ng-template pTemplate="content" styleClass="p-0">
        <!-- Header -->
        <div class="md:px-4 px-3 py-3 flex align-items-center justify-content-between border-bottom-1 border-300">
            <h2 class="mb-0 text-sm" data-testid="dialog-header">
                {{'FREEZE.FREEZE_EDIT.HEADER_EDITFREEZE' | translate}}
            </h2>
            <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="HidePopup()" 
                aria-label="close-dialog-button" data-testid="close-dialog-button"></div>
        </div>
        <!-- Header -->

        <!-- Content -->
        <form [formGroup]="fg" (submit)="EditFreeze()" data-testid="edit-freeze-form">
            <div class="surface-100 text-sm">
                <div class="p-3 border-bottom-1 border-300 flex">
                    <ng-container *ngIf="!IsRecurringSubscription">
                        <div class="w-6 pr-3" *ngIf="!isInProgresFreeze">
                            <label class="block text-xs text-600 mb-2 font-medium uppercase" data-testid="start-date-label">
                                {{'FREEZE.FREEZE_EDIT.LABEL_STARTDATE' | translate}}
                            </label>
                            <p-datepicker [showIcon]="true" styleClass="w-full"
                                placeholder="{{'FREEZE.FREEZE_EDIT.PLACEHOLDER_SELECTDATE' | translate}}"
                                formControlName="startdate" inputStyleClass="text-sm"
                                aria-label="start-date-calendar" data-testid="start-date-calendar">
                            </p-datepicker>
                            <app-error-msg *ngIf="StartDateControl?.touched && StartDateControl?.invalid"
                                [errors]="StartDateControl?.errors"
                                [fieldLabel]="'FREEZE.FREEZE_EDIT.STARTDATE' | translate"
                                data-testid="start-date-error">
                            </app-error-msg>
                        </div>
                        <div class="w-6 pl-3">
                            <label class="block text-xs text-600 mb-2 font-medium uppercase" data-testid="end-date-label">
                                {{'FREEZE.FREEZE_EDIT.LABEL_ENDDATE' | translate}}
                            </label>
                            <p-datepicker [showIcon]="true" styleClass="w-full"
                                placeholder="{{'FREEZE.FREEZE_EDIT.PLACEHOLDER_SELECTDATE' | translate}}"
                                formControlName="enddate" inputStyleClass="text-sm"
                                aria-label="end-date-calendar" data-testid="end-date-calendar">
                            </p-datepicker>
                            <app-error-msg *ngIf="EndDateControl?.touched && EndDateControl?.invalid"
                                [errors]="EndDateControl?.errors"
                                [fieldLabel]="'FREEZE.FREEZE_EDIT.ENDDATE' | translate"
                                data-testid="end-date-error">
                            </app-error-msg>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="IsRecurringSubscription">
                        <div class="w-6 pl-3">
                            <label class="block text-xs text-600 mb-2 font-medium uppercase" data-testid="freeze-cycle-label">
                                {{'FREEZE.FREEZE_EDIT.LABEL_FREEZECYCLE' | translate}}
                            </label>
                            <p-select [options]="(freezeTimeline$ | async)! || []"
                                formControlName="selectedfreezeattempt" optionLabel="strDateFormat" display="chip"
                                optionDisabled="is_frozen" styleClass="w-full text-sm"
                                placeholder="{{'FREEZE.FREEZE_EDIT.PLACEHOLDER_SELECTCYCLETOFREEZE' | translate}}"
                                aria-label="freeze-cycle-dropdown" data-testid="freeze-cycle-dropdown">
                                <ng-template pTemplate="selectedItem">
                                    <div class="text-sm" *ngIf="SelectedFreezeAttempt.value"
                                        [innerHTML]="SelectedFreezeAttempt.value.strDate" data-testid="selected-freeze-cycle">
                                    </div>
                                </ng-template>
                                <ng-template let-freezeAttempt pTemplate="item">
                                    <div class="text-sm" [innerHTML]="freezeAttempt.strDate" [attr.data-testid]="'freeze-cycle-option-' + freezeAttempt.id">
                                    </div>
                                </ng-template>
                            </p-select>
                            <app-error-msg *ngIf="SelectedFreezeAttempt?.touched && SelectedFreezeAttempt?.invalid"
                                [errors]="SelectedFreezeAttempt?.errors"
                                [fieldLabel]="'FREEZE.FREEZE_EDIT.ENDDATE' | translate"
                                data-testid="freeze-cycle-error">
                            </app-error-msg>
                        </div>
                    </ng-container>
                </div>

                <div class="p-3">
                    <label class="block text-xs text-600 mb-2 font-medium uppercase" data-testid="comments-label">
                        {{'FREEZE.FREEZE_EDIT.INPUT_COMMENTS' | translate}}
                    </label>
                    <textarea pInputTextarea formControlName="comment" class="text-sm w-full h-7rem"
                        placeholder="{{'FREEZE.FREEZE_EDIT.INPUT_COMMENTS' | translate}}"
                        aria-label="comments-textarea" data-testid="comments-textarea">
                    </textarea>
                    <app-error-msg *ngIf="CommentControl?.touched && CommentControl?.invalid"
                        [errors]="CommentControl?.errors"
                        [fieldLabel]="'FREEZE.FREEZE_EDIT.INPUT_COMMENTS' | translate"
                        data-testid="comments-error">
                    </app-error-msg>
                </div>

            </div>
            <!-- Content -->

            <!-- Footer -->
            <div class="p-3 flex justify-content-between align-items-center border-top-1 border-300">
                <button pButton pRipple type="button" label="{{'FREEZE.FREEZE_EDIT.BUTTON_CANCEL' | translate}}"
                    class="p-button-text text-sm" (click)="HidePopup()" styleClass="text-sm"
                    aria-label="cancel-freeze-edit-button" data-testid="cancel-freeze-edit-button">
                </button>
                <button pButton pRipple type="submit" label="{{'FREEZE.FREEZE_EDIT.BUTTON_SAVE' | translate}}"
                    class="text-sm" aria-label="save-freeze-edit-button" data-testid="save-freeze-edit-button">
                </button>
            </div>
            <!-- Footer -->
        </form>
    </ng-template>
</p-dialog>



<!-- <p-toast (onClose)="HidePopup()" [style]="{marginTop: '80px'}" styleClass="custom-toast">
    <ng-template let-message pTemplate="message">
        <div style="text-align: center">
            {{message.detail}}
        </div>
    </ng-template>
</p-toast> -->
<!-- Edit Freeze Modal -->
<app-errors *ngIf="showErrorPopup | async as show_Popup" [visible]="show_Popup" [errorData]="errorMessages"
    [error]="error" (hideErrorPopup)="HideErrorPopup($event)"
    aria-label="error dialog" data-testid="error-dialog">
</app-errors>